import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convertit une chaîne en slug URL-friendly
 * Supprime les accents, remplace les espaces par des tirets, supprime les caractères spéciaux
 */
export function slugify(text?: string | null): string {
  return (text ?? "")
    .normalize("NFD") // Décompose les caractères accentués
    .replace(/[\u0300-\u036f]/g, "") // Supprime les diacritiques
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // Supprime les caractères spéciaux sauf espaces et tirets
    .replace(/[\s_-]+/g, "-") // Remplace espaces et tirets multiples par un seul tiret
    .replace(/^-+|-+$/g, ""); // Supprime les tirets en début et fin
}

/**
 * Crée un slug pour un chef (prénom + ID)
 */
export function createChefSlug(
  firstName?: string | null,
  id?: number | null,
): string {
  return `${slugify(firstName)}-${id ?? 0}`;
}
